import { ENV, authFetch, parseResponse, SUCCESSARRAY } from "../utils";

export class Schema {
  async createSchema(data) {
    const schemaData = {
      id: data.id?.trim().toUpperCase(),
      name: data.name?.trim(),
      description: data.description?.trim() || "",
      order: Number(data.order),
    };

    const url = `${ENV.API_URL}/${ENV.ENDPOINTS.SCHEMA.SCHEMA}`;

    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(schemaData),
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getSchemas(page = 1, limit = 10, filters = {}) {
    const queryParams = new URLSearchParams({
      page,
      limit,
      ...filters,
    });

    const url =
      `${ENV.API_URL}/${ENV.ENDPOINTS.SCHEMA.SCHEMAS}` +
      `?${queryParams.toString()}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getSchema(schemaId) {
    const url =
      `${ENV.API_URL}/${ENV.ENDPOINTS.SCHEMA.SCHEMA}/${schemaId}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async updateSchema(schemaId, data) {
    const schemaData = {
      id: data.id?.trim().toUpperCase(),
      name: data.name?.trim(),
      description: data.description?.trim() || "",
      order: Number(data.order),
    };

    const url =
      `${ENV.API_URL}/${ENV.ENDPOINTS.SCHEMA.SCHEMA}/${schemaId}`;

    const params = {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(schemaData),
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async deleteSchema(schemaId) {
    const url =
      `${ENV.API_URL}/${ENV.ENDPOINTS.SCHEMA.SCHEMA}/${schemaId}`;

    const params = {
      method: "DELETE",
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }
}